<div class="modal-header" ngxModalDraggable>
  <h4 class="modal-title">{{classificator?.DisplayName}}</h4>
  <div>
    <help-button *transloco="let h" [key]="h('help.ime.common.classificators')"/>
    <button type="button" class="btn-close" aria-label="Close" (click)="bsModalRef.dismiss()">
    </button>
  </div>
</div>
<div class="modal-body bg-light">
  <mes-web-classificator-edit *ngIf="classificator" (changed)="onChanged($event)" [classificator]="classificator" [response]="response"/>
</div>
<mes-web-edit-modal-buttons [entityId]="classificatorId"
                            [hasDeleteButton]="(!classificator?.IsSystem && !!classificatorId)"
                            [isPristine]="isPristine$ | async"
                            [requiredPrivileges]="[PRIVILEGES.EditCommonData]"
                            (deleteClick)="delete()"
                            (saveClick)="save($event)"
                            (addClick)="add()"
                            (cancelClick)="bsModalRef.dismiss()"/>
